(function () {
  function normalizeOptionValue(v) {
    if (v == null || typeof v === "boolean") return v;
    return String(v).replace(/\u00a0/g, " ").trim();
  }

  function formatMoneyFromCents(cents) {
    var amount = Number(cents || 0) / 100;
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function getFormTotalCents(form) {
    if (!form) return null;
    if (form.totals && typeof form.totals.price !== "undefined") return form.totals.price;

    var firstSelector = form.querySelector("variant-selector");
    if (!firstSelector || !firstSelector.data) return null;
    var fallbackVariant =
      firstSelector.data.variant ||
      (firstSelector.data.variants || [])[0];
    return fallbackVariant ? fallbackVariant.price : null;
  }

  function updateAddToCartPriceLabel(form) {
    if (!form) return;
    var button = form.querySelector("button[form-validity-required]");
    if (!button) return;

    var totalCents = getFormTotalCents(form);
    if (totalCents === null || typeof totalCents === "undefined") return;

    var formattedPrice = formatMoneyFromCents(totalCents);
    button.innerHTML =
      'ADD TO CART <span class="atc-button__separator">-</span> <span class="atc-button__price">' +
      formattedPrice +
      "</span>";
  }

  function moveRingSizeBelowStone() {
    document.querySelectorAll("form").forEach(function (form) {
      var ringSizeLabel = form.querySelector('[data-selected-option-label="Ring Size"]');
      var stoneButton = form.querySelector(".button--stone");
      if (!ringSizeLabel || !stoneButton) return;

      var ringSizeField = ringSizeLabel.closest(".variant-selector__option");
      var stoneField = stoneButton.closest(".variant-selector__option");
      if (!ringSizeField || !stoneField || ringSizeField === stoneField) return;

      stoneField.insertAdjacentElement("afterend", ringSizeField);
    });
  }

  function normalizeOptionName(s) {
    if (s == null) return "";
    return String(s).replace(/\u00a0/g, " ").trim();
  }

  /**
   * variant-selector.option(name) requires `name` to exist on data.options; otherwise it
   * throws (reads `.values` of undefined). Match by option title or legacy optionN___handle.
   */
  function resolveProductOptionName(selector, controlName) {
    if (!controlName || !selector || !selector.data || !Array.isArray(selector.data.options)) {
      return null;
    }
    var opts = selector.data.options;
    var i;
    var normCtl = normalizeOptionName(controlName);
    for (i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var nm = typeof opt === "string" ? opt : opt && opt.name;
      if (nm === controlName) return nm;
      if (normalizeOptionName(nm) === normCtl) return nm;
    }
    var m = /^option(\d+)___/.exec(controlName);
    if (m) {
      var idx = parseInt(m[1], 10) - 1;
      if (idx >= 0 && idx < opts.length) {
        opt = opts[idx];
        return typeof opt === "string" ? opt : opt && opt.name;
      }
    }
    return null;
  }

  /** Map control name / data-option-name → logical option name used in product JSON. */
  function resolveLogicalNameForControl(selector, el) {
    if (!el) return null;
    var dn = el.getAttribute && el.getAttribute("data-option-name");
    return (
      resolveProductOptionName(selector, el.name) ||
      (dn ? resolveProductOptionName(selector, dn) : null)
    );
  }

  /**
   * variant-selector.variant() matches variant.options[i] with strict equality to selected values.
   * Use the exact string from data.options[].values[].value (NBSP/trim-safe lookup only).
   */
  function resolveCanonicalOptionValue(selector, logicalName, raw) {
    if (raw === "" || raw == null || typeof raw === "boolean") return raw;
    if (!selector || !selector.data || !Array.isArray(selector.data.options)) return raw;
    var opt = selector.data.options.find(function (o) {
      return o && o.name === logicalName;
    });
    if (!opt || !Array.isArray(opt.values)) return raw;
    var normRaw = normalizeOptionValue(raw);
    var i;
    for (i = 0; i < opt.values.length; i++) {
      var row = opt.values[i];
      if (!row) continue;
      if (row.value === raw) return row.value;
    }
    for (i = 0; i < opt.values.length; i++) {
      var row2 = opt.values[i];
      if (!row2) continue;
      if (normalizeOptionValue(row2.value) === normRaw) return row2.value;
    }
    return raw;
  }

  function resolveRingSizeSelection(selector) {
    if (!selector) return null;

    var sel = selector.querySelector('select[name="Ring Size"], select[data-option-name="Ring Size"]');
    if (!sel) sel = document.querySelector('select[data-option-name="Ring Size"]');

    var selVal = sel ? sel.value : null;

    console.log("[resolveRingSize] native select:", selVal);

    if (selVal) return selVal;
    return null;
  }

  function resolveRingSizeLogicalName(selector) {
    if (!selector || !selector.data || !Array.isArray(selector.data.options)) return null;
    var direct = resolveProductOptionName(selector, "Ring Size");
    if (direct) return direct;

    var domSelect =
      selector.querySelector('select[name="Ring Size"], select[data-option-name="Ring Size"]') ||
      selector.querySelector("select");
    if (domSelect) {
      var byDom = resolveLogicalNameForControl(selector, domSelect);
      if (byDom && normalizeOptionName(byDom).indexOf("ring") !== -1 && normalizeOptionName(byDom).indexOf("size") !== -1) {
        return byDom;
      }
    }

    var i;
    for (i = 0; i < selector.data.options.length; i++) {
      var o = selector.data.options[i];
      var nm = normalizeOptionName(typeof o === "string" ? o : o && o.name);
      if (nm.indexOf("ring") !== -1 && nm.indexOf("size") !== -1) {
        return typeof o === "string" ? o : o && o.name;
      }
    }
    return null;
  }

  /**
   * Read the ring size. Priority:
   * 1. window.__ringSizeExplicit (global var — survives full DOM destruction)
   * 2. data-user-ring-size on the picker wrapper
   * 3. .is-selected grid button
   * 4. native select value
   */
  function getPickerRingSize(selector) {
    if (window.__ringSizeExplicit) return window.__ringSizeExplicit;
    var wrapper = selector.querySelector(".ring-size-picker[data-user-ring-size]");
    if (wrapper) {
      var userVal = wrapper.getAttribute("data-user-ring-size");
      if (userVal) return userVal;
    }
    var btn = selector.querySelector(".ring-size-picker__option.is-selected");
    if (btn) return btn.getAttribute("data-ring-size-value") || btn.textContent.trim();
    return null;
  }

  function selectedValuesByLogicalName(selector) {
    var out = {};

    selector.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
      var logical = resolveLogicalNameForControl(selector, input);
      if (!logical) return;
      out[logical] = resolveCanonicalOptionValue(selector, logical, input.value);
    });

    selector.querySelectorAll("select").forEach(function (select) {
      if (!select.name || select.name === "id") return;
      if (!select.value || select.value === "") {
        // Native select may have been reset to placeholder by framework — skip for now,
        // custom picker override below will supply the real value.
        return;
      }
      var logical = resolveLogicalNameForControl(selector, select);
      if (!logical) return;
      out[logical] = resolveCanonicalOptionValue(selector, logical, select.value);
    });

    selector.querySelectorAll('input[type="hidden"]').forEach(function (input) {
      if (!input.name || input.name === "id" || !input.value) return;
      var logical = resolveLogicalNameForControl(selector, input);
      if (!logical) return;
      if (typeof out[logical] !== "undefined") return;
      out[logical] = resolveCanonicalOptionValue(selector, logical, input.value);
    });

    // Custom picker is the authoritative source for ring size — always wins.
    var pickerSize = getPickerRingSize(selector);
    if (pickerSize) {
      var ringLogical = resolveRingSizeLogicalName(selector);
      if (ringLogical) {
        var canonical = resolveCanonicalOptionValue(selector, ringLogical, pickerSize);
        if (canonical) {
          out[ringLogical] = canonical;
        }
      }
    }

    return out;
  }

  function buildOptionIndexByName(selector) {
    var byName = {};
    selector.data.options.forEach(function (o, idx) {
      var nm = typeof o === "string" ? o : o && o.name;
      if (!nm) return;
      var ix = typeof o === "object" && o && typeof o.index === "number" ? o.index : idx;
      byName[nm] = ix;
    });
    return byName;
  }

  function findExactVariant(selector, chosen) {
    if (!selector || !selector.data || !Array.isArray(selector.data.variants) || !Array.isArray(selector.data.options)) return null;
    var byName = buildOptionIndexByName(selector);
    var keys = Object.keys(chosen).filter(function (k) {
      return typeof byName[k] === "number";
    });
    if (!keys.length) return null;
    return (
      selector.data.variants.find(function (v) {
        if (!v || !Array.isArray(v.options)) return false;
        return keys.every(function (name) {
          var ix = byName[name];
          return normalizeOptionValue(v.options[ix]) === normalizeOptionValue(chosen[name]);
        });
      }) || null
    );
  }

  /**
   * Force data.variant to match the visible UI state (metal swatches, ring size picker, stone
   * picker hiddens). Inline variant matching to avoid reliance on patched prototype methods.
   */
  /**
   * If the custom picker has an active size that differs from the native select, push it back
   * into the native select so the two stay in sync (the framework can reset the native one).
   */
  function resyncNativeSelectFromPicker(selector) {
    var pickerSize = getPickerRingSize(selector);
    if (!pickerSize) return;
    var sel = selector.querySelector('select[name="Ring Size"], select[data-option-name="Ring Size"]');
    if (!sel) return;
    var normPicker = normalizeOptionValue(pickerSize);
    var normSel = normalizeOptionValue(sel.value);
    if (normSel === normPicker) return;
    var opts = Array.from(sel.options);
    var match = opts.find(function (o) {
      return normalizeOptionValue(o.value) === normPicker;
    });
    if (match) {
      match.disabled = false;
      sel.selectedIndex = opts.indexOf(match);
      console.log("[resync] native select forced back to picker value:", pickerSize, "(was:", normSel + ")");
    }
  }

  function syncAllOptionsFromDom(selector) {
    if (!selector || !selector.data || !Array.isArray(selector.data.options)) {
      console.log("[sync] SKIP: selector missing or no data/options");
      return;
    }
    if (!Array.isArray(selector.data.variants)) {
      console.log("[sync] SKIP: no variants array");
      return;
    }

    resyncNativeSelectFromPicker(selector);

    selector.data.preselect = false;

    var chosen = selectedValuesByLogicalName(selector);
    var names = Object.keys(chosen);
    console.log("[sync] chosen from DOM:", JSON.stringify(chosen));
    if (!names.length) {
      console.log("[sync] SKIP: no options found in DOM");
      return;
    }

    selector.data.options.forEach(function (opt) {
      if (!opt || !opt.name) return;
      var val = chosen[opt.name];
      if (val != null) {
        opt.selected = { value: val, order: opt.selected ? opt.selected.order : 1 };
      }
    });

    var matches = selector.data.variants.slice();
    selector.data.options.forEach(function (opt) {
      if (!opt || !opt.selected) return;
      var idx = typeof opt.index === "number" ? opt.index : selector.data.options.indexOf(opt);
      var val = opt.selected.value;
      var before = matches.length;
      matches = matches.filter(function (v) {
        return v && Array.isArray(v.options) && v.options[idx] == val;
      });
      console.log("[sync] filter by", opt.name, "=", val, "(index:", idx, ") →", before, "→", matches.length);
    });

    if (matches.length >= 1) {
      selector.data.variant = matches[0];
      console.log("[sync] ✓ forced variant:", matches[0].id, "options:", matches[0].options);
      var idSel = selector.querySelector('select[name="id"]');
      if (idSel) idSel.value = String(matches[0].id);
      var form = selector.closest("form");
      if (form) form.setAttribute("validated", "true");
    } else {
      console.log("[sync] ✗ NO matching variant found! Current data.variant:", selector.data.variant && selector.data.variant.id);
    }
  }

  function syncPrecheckedSwatches(selector) {
    syncAllOptionsFromDom(selector);
  }

  // Expose so ring-size-enhancer can call directly (change events may be stopped by framework).
  window.__syncAllOptionsFromDom = syncAllOptionsFromDom;

  function patchVariantSelectorProtoOnce() {
    var Ctor = customElements.get("variant-selector");
    if (!Ctor || Ctor.__patchedSafeIter) return;
    Ctor.__patchedSafeIter = true;
    var proto = Ctor.prototype;
    var origTotal = proto.total;
    if (typeof origTotal === "function") {
      proto.total = function () {
        try {
          return origTotal.call(this);
        } catch (e) {
          /* constructor race: sibling <variant-selector> may not have .data yet */
        }
      };
    }
    var origValidate = proto.validate;
    if (typeof origValidate === "function") {
      proto.validate = function () {
        try {
          return origValidate.call(this);
        } catch (e) {
          /* same */
        }
      };
    }
  }

  function enhanceVariantSelectors() {
    if (!window.customElements || typeof customElements.whenDefined !== "function") return;
    customElements.whenDefined("variant-selector").then(function () {
      patchVariantSelectorProtoOnce();
      document.querySelectorAll("variant-selector").forEach(syncPrecheckedSwatches);
    });
  }

  function getVariantPriceForLabel(selector) {
    if (!selector || !selector.data) return "";
    var v = selector.data.variant;
    if (!v && Array.isArray(selector.data.variants) && selector.data.variants.length) {
      v = selector.data.variants[0];
    }
    if (!v || v.price == null) return "";
    return " (" + formatMoneyFromCents(v.price) + ")";
  }

  function updateSelectedOptionLabels(selector) {
    if (!selector) return;
    var spans = selector.querySelectorAll("[data-selected-option-label]");

    spans.forEach(function (span) {
      var optionName = span.getAttribute("data-selected-option-label");
      if (!optionName) return;
      if (optionName === "Custom Engraving") {
        span.textContent = "Ready to ship.";
        return;
      }

      var isStone = optionName === "Center Stone Selection";
      var priceSuffix = isStone ? getVariantPriceForLabel(selector) : "";

      var selectedRadio = selector.querySelector('input[type="radio"][name="' + optionName + '"]:checked');
      if (selectedRadio) {
        span.textContent = selectedRadio.value + priceSuffix;
        return;
      }

      var select = selector.querySelector('select[name="' + optionName + '"]');
      if (select && select.value) {
        span.textContent = select.value + priceSuffix;
        return;
      }

      var hidden = selector.querySelector('input[type="hidden"][name="' + optionName + '"]');
      if (hidden && hidden.value) {
        span.textContent = hidden.value + priceSuffix;
      }
    });
  }

  document.addEventListener("change", function (event) {
    var selector = event.target.closest("variant-selector");
    if (!selector) return;
    var form = selector.closest("form");
    syncAllOptionsFromDom(selector);
    updateSelectedOptionLabels(selector);
    updateAddToCartPriceLabel(form);
    setTimeout(function () {
      syncAllOptionsFromDom(selector);
      updateAddToCartPriceLabel(form);
    }, 0);
    setTimeout(function () { updateAddToCartPriceLabel(form); }, 150);
    setTimeout(function () { updateAddToCartPriceLabel(form); }, 400);
  });

  /** Last-chance sync before submit — runs on ALL cart/add forms regardless of button attributes. */
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      console.log("[submit capture] fired, form:", form && form.getAttribute("action"));
      if (!form || !form.querySelectorAll) return;
      var selectors = form.querySelectorAll("variant-selector");
      console.log("[submit capture] found", selectors.length, "variant-selector(s) in form");
      selectors.forEach(syncAllOptionsFromDom);
    },
    true
  );

  document.addEventListener(
    "pointerdown",
    function (event) {
      var btn = event.target.closest("button[form-validity-required], button[type='submit'], [name='add'], .product-form__submit");
      if (!btn) return;
      var form = btn.closest("form");
      if (!form) return;
      form.querySelectorAll("variant-selector").forEach(syncAllOptionsFromDom);
    },
    true
  );

  enhanceVariantSelectors();

  document.addEventListener("DOMContentLoaded", function () {
    enhanceVariantSelectors();
    moveRingSizeBelowStone();
    document.querySelectorAll("form").forEach(updateAddToCartPriceLabel);
  });

  document.querySelectorAll("variant-selector").forEach(function (selector) {
    updateSelectedOptionLabels(selector);
    updateAddToCartPriceLabel(selector.closest("form"));
  });

  // Covers async section swaps where DOM is replaced after initial load.
  requestAnimationFrame(function () {
    enhanceVariantSelectors();
    moveRingSizeBelowStone();
    document.querySelectorAll("form").forEach(updateAddToCartPriceLabel);
  });
  setTimeout(function () {
    enhanceVariantSelectors();
    moveRingSizeBelowStone();
    document.querySelectorAll("form").forEach(updateAddToCartPriceLabel);
  }, 150);
  setTimeout(function () {
    enhanceVariantSelectors();
    document.querySelectorAll("form").forEach(updateAddToCartPriceLabel);
  }, 400);

  // Watch Neptune's reactive price element for changes and sync ATC button price.
  (function observeProductPrice() {
    var priceEl = document.querySelector(".product-price");
    if (!priceEl) return;
    var form = priceEl.closest("form");
    if (!form) return;
    var obs = new MutationObserver(function () {
      updateAddToCartPriceLabel(form);
      setTimeout(function () { updateAddToCartPriceLabel(form); }, 50);
    });
    obs.observe(priceEl, { childList: true, subtree: true, characterData: true });
  })();

  /**
   * Last-resort safety net: patch Cart.add to fix ring-size variant IDs before sending to server.
   * For each item being added, finds the matching variant-selector by product_id, reads the
   * visible ring-size selection from the picker, and resolves the correct variant.
   */
  function patchCartAdd() {
    if (!window.Cart || typeof Cart.add !== "function") return;
    if (Cart.__ringSizePatched) return;
    Cart.__ringSizePatched = true;
    var origAdd = Cart.add;
    Cart.add = function (items) {
      if (!Array.isArray(items)) return origAdd.apply(this, arguments);
      console.log("[Cart.add] intercepted, items:", JSON.stringify(items.map(function(i){return {id:i.id, product_id:i.product_id}})));
      var allSelectors = document.querySelectorAll("variant-selector");
      var fixed = items.map(function (item) {
        var vs = null;
        var vsFallback = null;
        allSelectors.forEach(function (el) {
          if (el.data && el.data.id === item.product_id) {
            if (el.querySelector('select[data-option-name="Ring Size"]') || el.querySelector('[data-selected-option-label="Ring Size"]')) {
              vs = el;
            } else {
              vsFallback = el;
            }
          }
        });
        if (!vs) vs = vsFallback;
        if (!vs || !vs.data || !Array.isArray(vs.data.options) || !Array.isArray(vs.data.variants)) {
          console.log("[Cart.add] no matching variant-selector for product_id:", item.product_id);
          return item;
        }

        var ringOptionName = null;
        for (var i = 0; i < vs.data.options.length; i++) {
          var o = vs.data.options[i];
          var nm = (typeof o === "string" ? o : o && o.name) || "";
          if (nm.toLowerCase().indexOf("ring") !== -1 && nm.toLowerCase().indexOf("size") !== -1) {
            ringOptionName = typeof o === "string" ? o : o.name;
            break;
          }
        }
        if (!ringOptionName) {
          console.log("[Cart.add] product has no Ring Size option, passing through");
          return item;
        }

        var chosen = selectedValuesByLogicalName(vs);
        console.log("[Cart.add] chosen from DOM:", JSON.stringify(chosen));

        if (!chosen[ringOptionName] && window.__ringSizeExplicit) {
          chosen[ringOptionName] = resolveCanonicalOptionValue(vs, ringOptionName, window.__ringSizeExplicit);
          console.log("[Cart.add] Ring Size injected from global:", chosen[ringOptionName]);
        }
        if (!chosen[ringOptionName]) {
          console.log("[Cart.add] Ring Size NOT in chosen — skipping correction (would make it worse)");
          return item;
        }

        var matches = vs.data.variants.slice();
        vs.data.options.forEach(function (opt) {
          if (!opt || !opt.name || !chosen[opt.name]) return;
          var idx = typeof opt.index === "number" ? opt.index : vs.data.options.indexOf(opt);
          var val = chosen[opt.name];
          matches = matches.filter(function (v) {
            return v && Array.isArray(v.options) && v.options[idx] == val;
          });
        });

        if (matches.length >= 1) {
          console.log("[Cart.add] ✓ corrected variant:", item.id, "→", matches[0].id, "options:", matches[0].options);
          return { id: matches[0].id, product_id: item.product_id, properties: item.properties || {} };
        }
        console.log("[Cart.add] ✗ no matching variant found, using original id:", item.id);
        return item;
      });
      return origAdd.call(this, fixed);
    };
  }

  if (window.Cart) {
    patchCartAdd();
  } else {
    document.addEventListener("DOMContentLoaded", patchCartAdd);
    setTimeout(patchCartAdd, 500);
    setTimeout(patchCartAdd, 1500);
  }
})();
